// useChannelGroup — resolve channelId pra GroupedChannel usando cache.
//
// Pra abrir PiP, precisamos do GroupedChannel (singleton player exige
// pra dedup por group.key + auto-switch entre fontes). Cache de
// 'live-all-channels' tem o catálogo agrupável. Fallback:
// singleChannelGroup (channel virou seu próprio "grupo" 1×1).

import type { GroupedChannel, LiveChannel } from '@app-iptv/iptv-client'
import { groupLiveChannels } from '@app-iptv/iptv-client'
import { useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'

import { singleChannelGroup } from '../screens/live/helpers'

export function useChannelGroup(channelId: string | null): GroupedChannel | null {
  const qc = useQueryClient()

  return useMemo(() => {
    if (!channelId) return null
    const cached = qc.getQueriesData<LiveChannel[]>({
      predicate: (q) => q.queryKey.some((k) => k === 'live-all-channels'),
    })
    const firstList = cached.find(([, data]) => Array.isArray(data) && data.length > 0)?.[1] ?? []
    if (firstList.length === 0) return null
    const groups = groupLiveChannels(firstList, { ignoreCategory: true })
    const found = groups.find((g) => g.sources.some((s) => s.channelId === channelId))
    if (found) return found
    // Fallback: canal solto sem variantes — usa singleChannelGroup.
    const channel = firstList.find((c) => c.id === channelId)
    if (channel) return singleChannelGroup(channel)
    return null
  }, [channelId, qc])
}
